import axios from 'axios';

import { ChangePasswordForm } from '@/pages/change-password';
import { EnvironmentService } from '@/services/EnvironmentService';

const BASE_ENDPOINT = `${EnvironmentService.getPublicApiURL()}/account`;

const PASSWORD_ENDPOINT = `${BASE_ENDPOINT}/password`;

const REMIND_ENDPOINT = `${PASSWORD_ENDPOINT}/remind`;

function activate(token: string) {
    const url = new URL(`${PASSWORD_ENDPOINT}/activate`);
    url.searchParams.set('token', encodeURI(token));
    // return axios.post(url.toString());
    return new Promise((resolve) => resolve(true));
}

function changePassword(data: ChangePasswordForm) {
    const url = new URL(PASSWORD_ENDPOINT);
    return axios.put(url.toString(), data);
}

function remindPassword(memberEmail: string) {
    const url = new URL(REMIND_ENDPOINT);
    url.searchParams.set('email', memberEmail);
    return axios.post(url.toString());
}

function resetPassword(hash: string, newPassword: string) {
    const url = new URL(`${REMIND_ENDPOINT}/reset`);
    const payload = {
        hash,
        newPassword
    };
    return axios.post(url.toString(), payload);
}

async function verifyRemindPasswordHash(hash: string) {
    const url = new URL(`${REMIND_ENDPOINT}/${hash}`);
    return axios.get(url.toString());
}

export const AccountService = {
    activate,
    changePassword,
    remindPassword,
    resetPassword,
    verifyRemindPasswordHas: verifyRemindPasswordHash
};
